module.exports = __webpack_public_path__ + "static/media/ls-bg-pattern.eb1fca83.png";